import 'axios';
import { httpClient } from '../../utils/http-client';
let cachedBetaRequest = null;
export async function isBetaUser() {
    if (!window.uData)
        return false;
    if (cachedBetaRequest != null)
        return cachedBetaRequest;
    const response = await httpClient.get('/beta');
    const data = response.data.map((item) => Number.parseInt(item));
    if (data.includes(window.uData.id)) {
        cachedBetaRequest = true;
        return true;
    }
    cachedBetaRequest = false;
    return false;
}
export async function beta(node) {
    if (node && !(await isBetaUser()))
        node.style.display = 'none';
}
